import { Eye, EyeOff } from "lucide-react";
import { LockIcon } from "../icons";

export const PasswordInput = ({
  register,
  validationError,
  showPassword,
  togglePasswordVisibility,
  focusedField,
  setFocusedField,
}) => {
  const isFocused = focusedField === "password";

  return (
    <div>
      <label
        htmlFor="password"
        className="block text-sm font-medium text-gray-700"
      >
        Password
      </label>
      <div
        className={`mt-1 relative rounded-md ${
          isFocused ? "ring-2 ring-indigo-500" : ""
        }`}
      >
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <LockIcon
            className={`h-5 w-5 ${
              isFocused ? "text-indigo-500" : "text-gray-400"
            }`}
          />
        </div>
        <input
          {...register("password")}
          id="password"
          name="password"
          type={showPassword ? "text" : "password"}
          onFocus={() => setFocusedField("password")}
          onBlur={() => setFocusedField(null)}
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "password-error" : undefined}
          className={`block w-full pl-10 pr-10 py-3 border ${
            validationError ? "border-red-300" : "border-gray-300"
          } rounded-lg shadow-sm`}
          placeholder="••••••••"
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
          onClick={togglePasswordVisibility}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? (
            <EyeOff className="h-5 w-5 text-gray-500" />
          ) : (
            <Eye className="h-5 w-5 text-gray-500" />
          )}
        </button>
      </div>
      {validationError && (
        <p className="mt-2 text-sm text-red-600" id="password-error">
          {validationError.message}
        </p>
      )}
    </div>
  );
};
